import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The `}<inlineCode parentName="p">{`valueToken`}</inlineCode>{` representing the actual CVV value not accessible for security reasons.`}</p>
    <p>{`You can forward the token to `}<inlineCode parentName="p">{`HeadlessVaultManager.startPaymentFlow`}</inlineCode>{` as the `}<inlineCode parentName="p">{`cvv`}</inlineCode>{` parameter and under the hood it will be replaced with the value entered by the user.`}</p>
    <p>{`You can also access the `}<inlineCode parentName="p">{`valueToken`}</inlineCode>{` and be informed of when it changes using `}<inlineCode parentName="p">{`addListener('change', listener)`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// use \`metadata\` to check for validation errors
if (cvvInput.metadata.error) {
    // display errors, don't start the payment flow
    return
}
try {
    vaultManager.startPaymentFlow(vaultedPaymentMethod.id, {
        cvv: cvvInput.valueToken,
    })
} catch (error) {
    // Handle startPaymentFlow errors
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      